import React, { useState } from 'react';
import styles from './OldNav.module.css';

const OldNav = () => {
  const [showMobilemenu, setShowMobilemenu] = useState(false);

  const toggleMobileMenu = () => {
    setShowMobilemenu(!showMobilemenu);
  };

  return (
    <>
      <nav>
        <a className={styles.logo} href="https://www.wonder.inc/">
          <img src="https://www.wonder.inc/wonder-logo-white.png" />
        </a>
        <ul>
          <li className={styles.aboutUs}>
            <a href="https://www.wonder.inc/about-us">About Us</a>
          </li>
          <li>
            <a href="https://accounts.wonder.inc/login">Sign In</a>
          </li>
          <li className={styles.hamburger} onClick={() => toggleMobileMenu()}>
            <img src="https://www.wonder.inc/hamburger.png" />
          </li>
        </ul>
      </nav>
      <div
        className={styles.mobileMenu}
        style={showMobilemenu ? { display: 'block' } : { display: 'none' }}
      >
        <div id={styles.close} onClick={() => toggleMobileMenu()}>
          <img src="https://www.wonder.inc/close.png" />
        </div>
        <ul>
          <li>
            <a href="https://www.wonder.inc/">Home</a>
          </li>
          <li>
            <a href="https://www.wonder.inc/dynascore">Dynascore</a>
          </li>
          <li className={styles.subnav}>
            <a href="https://www.wonder.inc/dynascore">Overview</a>
          </li>
          <li className={styles.subnav}>
            <a href="https://www.wonder.inc/dynascore/browse">Browse</a>
          </li>
          <li className={styles.subnav}>
            <a href="https://www.wonder.inc/dynascore/under-the-hood">
              Under The Hood
            </a>
          </li>
          <li className={styles.subnav}>
            <a href="https://www.wonder.inc/dynascore/using-dynamic-music">
              Using Dynamic Music
            </a>
          </li>
          <li className={styles.subnav}>
            <a href="https://www.wonder.inc/dynascore/pricing">Pricing</a>
          </li>
          <li>
            <a href="https://www.wonder.inc/about-us">About Us</a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default OldNav;
